import React, { useState, useContext } from 'react';
import { Space, Typography, Alert,  Row, Form, Input, Button } from 'antd';
import { WarningFilled, DeleteOutlined } from '@ant-design/icons';
import { Modal } from '../../UI/Modal/Modal.component';
import { StationContext } from '../../../context/station-context';
import { saveStation } from '../../../services/StationService';
import { NocItemContext } from '../../../context/noc-item-context';
import { useNotificationApi } from '../../UI/NotificationProvider';

const { Text, Paragraph, Title } = Typography;

export const DeleteStationModal = ({ deleteStationModal, setDeleteStationModal, ...props}) => {
    
    const notificationApi = useNotificationApi();

    const [ nocItem, dispatchNocItem] = useContext(NocItemContext);
    const [ stationState, dispatchStation ] = useContext(StationContext);
    const { station } = stationState;

    const [loading, setLoading] = useState(false);

    const handleDelete = () => {
        setLoading(true)
        saveStation({dbID: station.id, deleted: true}).then(function (response) {
            if( response.result) {  
                openSuccessNotification();

                dispatchNocItem({
                    type: 'DELETE_STATION', 
                    payload: station.id, 
                })
                
                // Restart customer view
                dispatchNocItem({
                    type: 'START',
                })
            } else {
                notificationApi.error({
                    description: 'Something went wrong. Please try again.', 
                    duration: 6,
                });
            }
            setLoading(false);
            setDeleteStationModal(false);
        });
    }

    const openSuccessNotification = () => {
        notificationApi.success({
            message: 'Success!',
            description: `Station ${station.name} has been successfully deleted.`,
            duration: 6,
        });
    };

    const loadingMessage = (
        <>
            <Title level={5}>Deleting station...</Title>
            <Paragraph>Please wait, this action may take a few minutes.</Paragraph>
        </>
    );

    return(
        <>
            <Modal
                icon={<WarningFilled/>}
                color="var(--error-color)"
                title="Delete Station"
                justifyTitle="middle"
                visible={deleteStationModal}
                setVisible={setDeleteStationModal}
                actionGroup={false}
                loading={loading}
                loadingMessage={loadingMessage}
                width={420}
            >
                <Alert
                    message= {<Text strong style={{color: "var(--error-color)"}}>{station.name}<br/>Total Devices: {station.Devices?.length}</Text>}
                    type="error"
                    closable={false}
                    style={{marginBottom: 15, textAlign: 'center'}}
                />
                
                <Paragraph>
                    Are you sure you want to delete this site/station? All data from this station will be permanently removed and you won't be able to undo this action.
                </Paragraph>
                <Paragraph>Please type <strong>"DELETE"</strong> to confirm: </Paragraph>
            
                <Form
                    name='delete-station-form'
                    autoComplete='off'
                    layout='vertical'
                    preserve={false}
                    onFinish={() => {handleDelete()}}
                    >
                    <Form.Item 
                        name='delete'
                        rules={[
                            {
                                required: true,
                                validateTrigger: 'onSubmit',
                                validator: (_, value) => {
                                        if(value === 'DELETE'){
                                            return Promise.resolve();
                                        }
                                        return Promise.reject(new Error('Please enter "DELETE" if you want to proceed.'));
                                    }
                                }
                            ]}
                        >
                        <Input style={{textAlign: 'center', }} onInput={(e) => e.target.value = e.target.value.toUpperCase()}/>
                    </Form.Item>
                    <Row justify='end'>   
                        <Form.Item noStyle>
                            <Space>
                                <Button onClick={() => setDeleteStationModal(false)}>Cancel</Button>
                                <Button htmlType='submit' type='primary' danger icon={<DeleteOutlined/>}>Yes, delete station</Button>
                            </Space>
                        </Form.Item>
                    </Row>
                </Form>
            </Modal>     
        </>
    )
};